import { useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import { FileOrLink } from "models/attachments";

type DupCheckSignature = (typeId: number, fileOrLink: FileOrLink, filenames: string) => Promise<[
    boolean,
    string[]
]>;

type DupCheckResult = [
    DupCheckSignature,
    boolean
];

type UseTaskAttachmentDupCheckSignature = (taskId: number) => DupCheckResult;

const useTaskAttachmentDupCheck: UseTaskAttachmentDupCheckSignature = (taskId) => {    
    const [ loading, setLoading ] = useState<boolean>(false); 
    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const dupCheck: DupCheckSignature = async (typeId, fileOrLink, filenames) => {
        if (user && user.id_token && taskId && filenames && typeId && fileOrLink !== undefined) {
            setLoading(true);
            
            try {
                const resp = await fetcher(`/api/v3/tasks/${taskId}/attachments/dup-check?filenames=${filenames}&type=${typeId}&fileOrLink=${fileOrLink}`);

                if (!resp.ok) {
                    // RESPOND TO ERRORS
                }

                const response = await resp.json() as (any);                
                return [
                    response.exists,
                    response.filenames
                ]
            } catch (err) {
                // Will be done in BFLY-8658 or BFLY-9022
            } finally {                
                setLoading(false);
            }
        }
        else{
            setLoading(false);
        }

        return [ false, [] ];
    };

    return [
        dupCheck,
        loading
    ];
};

export default useTaskAttachmentDupCheck;